import { Routes } from '@angular/router';
import { CanActivateExternalSettingsGuard } from './core/guards/can-activate-external-settings.guard';
//
import { AuthGuardService } from './core/services/auth-guard.service';
import { RedirectGuardService } from './core/services/redirect-guard.service';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  {
    path: 'auth',
    loadChildren: () => import('./routes/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [RedirectGuardService],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./routes/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuardService],
    data: {
      expectedRole: 'dashboard',
    },
  },
  {
    path: 'accounts',
    loadChildren: () => import('./routes/accounts/accounts.module').then((m) => m.AccountsModule),
  },
  {
    path: 'clients',
    loadChildren: () => import('./routes/clients/clients.module').then((m) => m.ClientsModule),
    canActivate: [AuthGuardService],
    data: {
      expectedRole: 'clients',
    },
  },
  {
    path: 'inventory',
    loadChildren: () => import('./routes/inventory/inventory.module').then((m) => m.InventoryModule),
    canActivate: [AuthGuardService],
    data: {
      expectedRole: 'inventory',
      kiosk: true,
    },
  },
  {
    path: 'deal-editor',
    loadChildren: () => import('./routes/deal-editor/deal-editor.module').then((m) => m.DealEditorModule),
    canActivate: [AuthGuardService],
    data: {
      hidemenu: true,
      route: 'DEAL_EDITOR',
      kiosk: true,
    },
  },
  {
    path: 'billing',
    loadChildren: () => import('./routes/billing/billing.module').then((m) => m.BillingModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'criteria',
    loadChildren: () => import('./routes/criteria/criteria.module').then((m) => m.CriteriaModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'account-setup',
    loadChildren: () => import('./routes/account-setup/account-setup.module').then((m) => m.AccountSetupModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'customization',
    loadChildren: () => import('./routes/customization/customization.module').then((m) => m.CustomizationModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'pricing-fees',
    loadChildren: () => import('./routes/pricing-fees/pricing-fees.module').then((m) => m.PricingFeesModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'trade-in',
    loadChildren: () => import('./routes/trade-in/trade-in.module').then((m) => m.TradeInModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'groups',
    loadChildren: () => import('./routes/groups/groups.module').then((m) => m.GroupsModule),
    canActivate: [AuthGuardService, CanActivateExternalSettingsGuard],
    data: {
      expectedRole: 'groups',
    },
  },
  {
    path: 'system-settings',
    loadChildren: () => import('./routes/system-settings/system-settings.module').then((m) => m.SystemSettingsModule),
    canActivate: [AuthGuardService, CanActivateExternalSettingsGuard],
    data: {
      submenu: true,
      route: 'SYSTEM_SETTINGS',
      expectedRole: 'system',
    },
  },
  {
    path: 'users',
    loadChildren: () => import('./routes/users/users.module').then((m) => m.UsersModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'users',
    },
  },
  {
    path: 'profile',
    loadChildren: () => import('./routes/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'accessories',
    loadChildren: () => import('./routes/accessories/accessories.module').then((m) => m.AccessoriesModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'reports',
    loadChildren: () => import('./routes/reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuardService],
    data: {
      expectedRole: 'report',
    },
  },
  {
    path: 'protection',
    loadChildren: () => import('./routes/protection/protection.module').then((m) => m.ProtectionModule),
    canActivate: [AuthGuardService],
    data: {
      submenu: true,
      route: 'ACCOUNT_SETTINGS',
      expectedRole: 'settings',
    },
  },
  {
    path: 'support',
    loadChildren: () => import('./routes/support/support.module').then((m) => m.SupportModule),
    canActivate: [AuthGuardService],
    data: {
      expectedRole: 'support',
    },
  },
  {
    path: 'layout',
    loadChildren: () => import('./routes/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'style-guide',
    loadChildren: () => import('./routes/style-guide/style-guide.module').then((m) => m.StyleGuideModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'miscellaneous',
    loadChildren: () => import('./routes/miscellaneous/miscellaneous.module').then((m) => m.MiscellaneousModule),
  },
  {
    path: 'public',
    loadChildren: () => import('./routes/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'default',
    loadChildren: () => import('./routes/default/default.module').then((m) => m.DefaultModule),
  },
  {
    path: '**',
    redirectTo: 'miscellaneous/error404',
  },
];
